module.exports = __webpack_public_path__ + "static/img/fangan1.9f1defa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/fangan1.png
// module id = lmOJ
// module chunks = 1